import React from "react";
import { Navigate, useLocation } from "react-router-dom";

function normalizeNextPath(rawNext) {
  if (!rawNext) return "/";

  try {
    let decoded = decodeURIComponent(rawNext);

    if (/^https?:\/\//i.test(decoded)) {
      try {
        const u = new URL(decoded);
        decoded = `${u.pathname || "/"}${u.search || ""}${u.hash || ""}`;
      } catch {
        // keep decoded fallback below
      }
    }

    if (!decoded) decoded = "/";
    if (!decoded.startsWith("/")) decoded = `/${decoded}`;
    if (decoded.startsWith("//")) decoded = decoded.slice(1);

    return decoded;
  } catch {
    return "/";
  }
}

export default function IGGate() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const next = normalizeNextPath(params.get("next"));
  return <Navigate to={next} replace />;
}
